export default "/assets/images/widgets-background-dark.6f6bbd5a17e22bef.webp";